const Common = {
    namespaced: true,
    state: () => ({
        storeData:{},
    }),
    mutations: {
      SET_STORE_DATA(state, payload) {
       state.storeData = payload;
      },
    },
    actions: {
      setStoreData({ commit }, payload) {
        commit("SET_STORE_DATA", payload);
      },
    },
  };
  
  export default Common;